import { Button, Theme, useMediaQuery } from "@mui/material";
import { FC, useState } from "react";
import { StyledInput, StyledInputWrapper, StyledLeftColumnHeader, StyledWrapper } from "./styles";

import Icon from "../Icon";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LeftColumnItem from "./LeftColumnItem/LeftColumnItem";
import { LeftColumnProps } from "./types";
import PaginationButton from "../PaginationButton/PaginationButton";
import styled from "styled-components";
import { useLanguage } from "../../context/LocaleProvider";

const LeftColumn: FC<LeftColumnProps> = ({
  data,
  rows,
  onLoadNext,
  onLoadPrevious,
  onVehicleClick,
  onVehicleMapDetailClick,
  pageNum,
  pagesAmount,
  searchInputValue,
  onSearchInputChange,
  onItemClick
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const { search } = useLanguage();
  const [isOpened, setOpened] = useState(false);
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const toggleFocus = () => setIsInputFocused((prev) => !prev);

  return (
    <StyledWrapper isOpened={isOpened}>
      <StyledLeftColumnHeader isSmall={isSmall} style={isOpened ? {width: 70} : {}}>
        <MenuButton onClick={() => setOpened(!isOpened)}>
          {isOpened ? <KeyboardArrowRightIcon style={{ margin: 0 }} /> : <KeyboardArrowLeftIcon style={{ margin: 0 }} />}
        </MenuButton>
        <StyledInputWrapper style={isOpened ? {opacity: 0} : {}} isFocused={isInputFocused}>
          <StyledInput
            placeholder={search}
            value={searchInputValue}
            onChange={onSearchInputChange}
            onFocus={toggleFocus}
            onBlur={toggleFocus}
          />
          <Icon iconName="search" />
        </StyledInputWrapper>
        {!isOpened ? (
          <PaginationButton
            intent="previous"
            isVisible={pageNum !== 0}
            onClick={onLoadPrevious}
            icon={<Icon iconName="arrowUp" width="16" height="16" />}
            pageNum={pageNum}
            pagesAmount={pagesAmount}
          />
        ) : null}
      </StyledLeftColumnHeader>
      {data.map((item, index) => (
        <LeftColumnItem
          id={item.id}
          item={item.label}
          key={item.id}
          isOpened={isOpened}
          collapsed={item.collapsed}
          rows={rows[index]}
          onItemClick={onItemClick}
          onVehicleClick={onVehicleClick}
          onVehicleMapDetailClick={onVehicleMapDetailClick}
        />
      ))}
      {!isOpened ? (
        <PaginationButton
          intent="next"
          isVisible={pageNum !== pagesAmount - 1}
          onClick={onLoadNext}
          icon={<Icon iconName="arrowDown" width="16" height="16" />}
          pageNum={pageNum}
          pagesAmount={pagesAmount}
        />
      ) : null}
    </StyledWrapper>
  );
};

export default LeftColumn;

const MenuButton = styled(Button)`
  position: sticky !important;
  z-index: 1000;
  left: 100%;
  margin-right: 6px !important;
  min-width: 1px !important;
  top: 19px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
